/* The door size finder, one rule for every place it shows (Seth 2026-10-01 on How it works; 2026-10-10: the home page
   band under the hero, How it works and the collection pages' Door size bar; "all it does is apply the correct filters",
   "it just filters doors on the collection ... theyre already looking at").
   The rule (Seth 2026-10-10; the site never says it in words): for a rough opening, doors from 5 inches narrower to
   1 inch wider than the opening, and from 4 inches shorter to 2 inches taller, every size in eighth inches.
   Plans (like 2.8 x 6.8) and Door size give the door itself: 3 inches are added to reach the rough opening (Magnolia's
   Install Ready rule, the opening about 3 inches wider and taller than the door), then the same rule applies.
   A form marked data-mad-size-finder holds text boxes [data-w] [data-h] (inches) and, when it offers the switch,
   radios [data-mode] (ro, plans, door) with drop-downs [data-pw] [data-ph] (inches as values) for Plans. On submit it
   goes to data-target (a collection) filtered to the band. mad_range repeats the band in one parameter: Shopify's
   preview and theme editor keep only the last of repeated filter values, and the collection page
   (snippets/mad-range-runtime.liquid) then selects the full band. mad_size keeps what was entered ("plans:32x80"), so
   the finder on the results page shows it again. data-keep keeps the page's other filters and sort (the collection
   bar). Nothing is remembered between pages (Seth 2026-10-10: "No").
   Review of 2026-10-11 (independent check before go-live): the switch is set up again on pageshow, because Chrome puts
   back the chosen tab after the script ran when Back reloads a page (the store sends no-store); feet and inches
   (6'8", 6 ft 8) are read; a box holding something that is not a size gets a message instead of being dropped; an
   empty search keeps the page still; a size with no doors says so, with ways out, instead of "coming soon".
   Second check of 2026-10-11: the no-doors words come back after the theme's filters refresh the doors without a reload
   (removing a chip, Back), also when the address keeps the sizes but lost mad_size; empty filter boxes the theme writes
   into the address (filter.v.price.gte=) do not count as "other filters"; a message shown before the page finished
   loading stays; 6'-8", 3'-0", 36,5, 39. and 38½ are read. */
(function () {
  'use strict';
  if (window.MadSizeFinder) return;

  var TO_OPENING = { ro: 0, plans: 3, door: 3 };
  var BAND = { width: [-5, 1], height: [-4, 2] };
  /* sizes a visitor can mean, in inches, before the opening is added: the smallest door in the store is 16 wide and
     62 tall, so a "10" in the height box is ten feet typed without the mark, not a door size */
  var LIMITS = { width: [12, 200], height: [36, 200] };
  var MSG = {
    empty: 'Enter a width and we will show doors near it.',
    bad: 'Enter sizes in inches, like 39 and 99.'
  };

  var VULGAR = { '½': ' 1/2', '¼': ' 1/4', '¾': ' 3/4', '⅛': ' 1/8', '⅜': ' 3/8', '⅝': ' 5/8', '⅞': ' 7/8' };

  /* "38", "38.5", "38 1/2", "38-1/4", "38½", 38", "38 in", "39.", "36,5", and feet with inches (6'8", 6'-8" as on door
     schedules, 6' 8 1/2", 6 ft 8 in, 10') all read as inches; anything else is NaN. "6-8" stays NaN: it could be six and
     eight eighths or six feet eight. */
  function inches(s) {
    var t = String(s == null ? '' : s).trim().toLowerCase()
      .replace(/[‘’′`]/g, "'").replace(/[“”″]/g, '"').replace(/''/g, '"')
      .replace(/[½¼¾⅛⅜⅝⅞]/g, function (c) { return VULGAR[c]; })
      /* a comma decimal only as one digit or an eighth (36,5 or 38,125): "39,99" is two sizes in one box, and gets the
         message (final check of 2026-10-11) */
      .replace(/^(\d+),(\d|125|25|375|5|625|75|875)(?!\d)/, '$1.$2')
      .replace(/^(\d+)\.(?=\s*(?:"|in\.?|inch(?:es)?)?\s*$)/, '$1')
      .replace(/\s+/g, ' ').trim();
    if (!t) return NaN;
    var f = /^(\d+(?:\.\d+)?)\s*(?:'|ft\.?|feet|foot)\s*-?\s*(?:(\d+(?:\.\d+)?)(?:[\s-]+(\d+)\s*\/\s*(\d+))?\s*(?:"|in\.?|inch(?:es)?)?)?$/.exec(t);
    if (f) {
      var v = parseFloat(f[1]) * 12 + (f[2] ? parseFloat(f[2]) : 0);
      if (f[3] && Number(f[4])) v += Number(f[3]) / Number(f[4]);
      return v;
    }
    var m = /^(\d+(?:\.\d+)?)(?:[\s-]+(\d+)\s*\/\s*(\d+))?\s*(?:"|in\.?|inch(?:es)?)?$/.exec(t);
    if (!m) return NaN;
    var w = parseFloat(m[1]);
    if (m[2] && Number(m[3])) w += Number(m[2]) / Number(m[3]);
    return w;
  }

  function eighth(v) { return Math.round(v * 8) / 8; }
  function band(v, dim) {
    var b = BAND[dim] || BAND.width;
    return [Math.max(1, eighth(v + b[0])), eighth(v + b[1])];
  }
  function ok(v, dim) {
    var l = LIMITS[dim] || LIMITS.width;
    return typeof v === 'number' && !isNaN(v) && v >= l[0] && v < l[1];
  }
  function modeKey(mode) { return Object.prototype.hasOwnProperty.call(TO_OPENING, mode) ? mode : 'ro'; }
  function keyOf(part) {
    var k = part.split('=')[0].replace(/\+/g, ' ');
    try { return decodeURIComponent(k); } catch (e) { return k; }
  }

  /* The address of the doors for a w by h entry (inches, in the given mode) on base (a collection path), or '' when
     neither size is usable. keep: a query string whose other filters and sort stay (old sizes, mad_range, mad_size and
     the page number go). */
  function url(base, w, h, keep, mode) {
    mode = modeKey(mode);
    var add = TO_OPENING[mode];
    var params = [], ranges = [];
    if (keep) {
      String(keep).replace(/^\?/, '').split('&').forEach(function (p) {
        if (!p) return;
        var k = keyOf(p);
        if (k === 'filter.v.option.width' || k === 'filter.v.option.height' || k === 'mad_range' || k === 'mad_size' || k === 'page') return;
        params.push(p);
      });
    }
    var any = false;
    [['width', w], ['height', h]].forEach(function (d) {
      if (!ok(d[1], d[0])) return;
      any = true;
      var b = band(d[1] + add, d[0]);
      for (var k = b[0] * 8; k <= b[1] * 8; k++) params.push('filter.v.option.' + d[0] + '=' + String(Number((k / 8).toFixed(3))));
      ranges.push(d[0] + ':' + b[0] + '-' + b[1]);
    });
    if (!any) return '';
    params.push('mad_range=' + encodeURIComponent(ranges.join(',')));
    params.push('mad_size=' + encodeURIComponent(mode + ':' + (ok(w, 'width') ? w : '') + 'x' + (ok(h, 'height') ? h : '')));
    return (base || '/collections/all') + '?' + params.join('&');
  }

  /* The same page without any size: the "Clear the size" link on a page with no doors near the size. */
  function withoutSize(path, search) {
    var params = [];
    String(search || '').replace(/^\?/, '').split('&').forEach(function (p) {
      if (!p) return;
      var k = keyOf(p);
      if (k === 'filter.v.option.width' || k === 'filter.v.option.height' || k === 'mad_range' || k === 'mad_size' || k === 'page') return;
      params.push(p);
    });
    return path + (params.length ? '?' + params.join('&') : '');
  }

  /* What the page was searched with, from its mad_size: { mode, width, height } as entered, and the rough opening
     they stand for (roWidth, roHeight), which the opening-only bar shows. */
  function sizeFrom(search) {
    var raw = null;
    try { raw = new URLSearchParams(search || '').get('mad_size'); } catch (e) { raw = null; }
    var m = raw && /^(ro|plans|door):([\d.]*)x([\d.]*)$/.exec(raw);
    if (!m) return {};
    var out = { mode: m[1] }, add = TO_OPENING[m[1]];
    if (m[2] && ok(Number(m[2]), 'width')) { out.width = Number(m[2]); out.roWidth = Number(m[2]) + add; }
    if (m[3] && ok(Number(m[3]), 'height')) { out.height = Number(m[3]); out.roHeight = Number(m[3]) + add; }
    return out;
  }

  function tag(name) {
    /* snippets/mad-clarity.liquid holds markers until Clarity has started (window.madClarityEvent) */
    try { if (typeof window.madClarityEvent === 'function') window.madClarityEvent(name); else if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) { /* never block the search */ }
  }

  function modeOf(form) {
    var r = form.querySelector('[data-mode]:checked');
    return modeKey(r ? r.value : 'ro');
  }

  /* A message for the visitor beside the boxes ([data-error]); the bar, which has no such line, uses its hint line. */
  function say(form, text) {
    var box = form.querySelector('[data-error]');
    if (box) { box.textContent = text; box.hidden = !text; return; }
    var hint = form.querySelector('[data-hint]') || (form.parentNode && form.parentNode.querySelector('[data-hint]'));
    if (hint) hint.textContent = text;
  }

  /* Show the boxes for the chosen mode: Plans has drop-downs, the other two the inch boxes, whose labels say opening or
     door (data-ro, data-door on each label). keepSay: leave a message on screen (the re-sync after Back or load). */
  function setMode(form, mode, keepSay) {
    Array.prototype.forEach.call(form.querySelectorAll('[data-panel]'), function (p) {
      p.hidden = p.getAttribute('data-panel') !== (mode === 'plans' ? 'plans' : 'inches');
    });
    Array.prototype.forEach.call(form.querySelectorAll('[data-ro]'), function (el) {
      var t = el.getAttribute('data-' + mode) || el.getAttribute('data-ro');
      if (t) el.textContent = t;
    });
    if (!keepSay) say(form, '');
  }

  function bind(form) {
    if (!form || form.dataset.madSizeBound) return;
    form.dataset.madSizeBound = '1';
    var wBox = form.querySelector('[data-w]'), hBox = form.querySelector('[data-h]');
    var pw = form.querySelector('[data-pw]'), ph = form.querySelector('[data-ph]');
    var modes = form.querySelectorAll('[data-mode]');
    Array.prototype.forEach.call(modes, function (r) {
      r.addEventListener('change', function () { if (r.checked) setMode(form, r.value); });
    });
    [wBox, hBox, pw, ph].forEach(function (el) {
      if (el) el.addEventListener('input', function () { say(form, ''); });
    });
    if (form.hasAttribute('data-prefill')) {
      var s = sizeFrom(window.location.search);
      if (s.mode) {
        if (modes.length) {
          Array.prototype.forEach.call(modes, function (r) { r.checked = r.value === s.mode; });
          setMode(form, s.mode);
          if (s.mode === 'plans') {
            if (s.width && pw) pw.value = String(s.width);
            if (s.height && ph) ph.value = String(s.height);
          } else {
            if (s.width && wBox && !wBox.value) wBox.value = String(s.width);
            if (s.height && hBox && !hBox.value) hBox.value = String(s.height);
          }
        } else {
          if (s.roWidth && wBox && !wBox.value) wBox.value = String(s.roWidth);
          if (s.roHeight && hBox && !hBox.value) hBox.value = String(s.roHeight);
        }
      }
    }
    if (modes.length) setMode(form, modeOf(form));
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var mode = modeOf(form);
      var w = NaN, h = NaN, bad = null;
      if (mode === 'plans') {
        w = Number(pw && pw.value) || NaN;
        h = Number(ph && ph.value) || NaN;
      } else {
        var wt = wBox ? wBox.value.trim() : '', ht = hBox ? hBox.value.trim() : '';
        if (wt) w = inches(wt);
        if (ht) h = inches(ht);
        if (wt && !ok(w, 'width')) bad = wBox;
        else if (ht && !ok(h, 'height')) bad = hBox;
      }
      var keep = form.hasAttribute('data-keep') ? window.location.search : '';
      var to = bad ? '' : url(form.getAttribute('data-target'), w, h, keep, mode);
      if (!to) {
        say(form, bad
          ? (form.getAttribute('data-bad') || MSG.bad)
          : (form.getAttribute('data-empty-' + mode) || form.getAttribute('data-empty') || MSG.empty));
        var first = bad || (mode === 'plans' ? pw : wBox);
        if (first) { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }
        return;
      }
      tag('size_finder_' + (form.getAttribute('data-place') || 'page'));
      if (modes.length) tag('size_mode_' + mode);
      window.location.href = to;
    });
  }

  function bindAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mad-size-finder]'), bind);
  }

  /* Back reloads store pages (no-store), and Chrome restores a chosen tab only after the script ran, without a change
     event: line the boxes up with the tab again (the forms also ask for no restoring, autocomplete="off"). */
  function resync() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mad-size-finder]'), function (f) {
      if (f.querySelector('[data-mode]')) setMode(f, modeOf(f), true);
    });
  }

  /* The size part of an address: its width and height filter values only (for "See all doors near this size" when the
     address no longer says what was typed). */
  function sizeOnly(search) {
    var params = [];
    String(search || '').replace(/^\?/, '').split('&').forEach(function (p) {
      if (!p) return;
      var k = keyOf(p);
      if (k === 'filter.v.option.width' || k === 'filter.v.option.height') params.push(p);
    });
    return params.join('&');
  }

  /* Seth 2026-10-14 (his Clarity report: a visitor typed 96 by 60 again and again, found nothing and left; 60 by 96
     shows 9 doors): a width bigger than the height is most likely typed the wrong way round, so the page with no
     doors offers the swap first, one tap away. Returns [url, words] or null. */
  function swapOf(size, path, search) {
    if (!size || !size.width || !size.height || !(size.width > size.height)) return null;
    var to = url(path, size.height, size.width, search, size.mode);
    if (!to) return null;
    var n = function (v) { return String(Number(Number(v).toFixed(3))); };
    return [to, 'Did you mean ' + n(size.height) + ' wide \u00d7 ' + n(size.width) + ' tall?'];
  }

  /* A collection page searched by size that has no doors near it: say so plainly, with the way back to the doors, all
     doors near the same size, and a person to ask, instead of the empty-collection "coming soon" words. The words come
     from the Door size bar's settings (data-none-*) when the bar is on the page. Runs on load and again whenever the
     theme's filters refresh the doors without a reload (watchGrid, popstate). */
  function noneNear() {
    var search = window.location.search;
    var s = sizeFrom(search);
    var sized = sizeOnly(search);
    if (!s.mode && !sized) return;
    var grid = document.querySelector('.collection--empty');
    if (!grid || grid.querySelector('[data-mad-size-none]')) return;
    var title = grid.querySelector('.title-wrapper');
    if (!title) return;
    var bar = document.querySelector('.mad-sizebar [data-mad-size-finder]');
    var words = function (k, d) { return (bar && bar.getAttribute('data-none-' + k)) || d; };
    var path = window.location.pathname;
    /* After a refresh without reload the address keeps only the sizes this collection has (the theme rebuilds it from
       its own boxes), so "See all doors" uses the size the page was searched with, while the address still lies inside
       that band; otherwise the link is left out rather than search too narrowly (final check of 2026-10-11). */
    var from = s.mode ? s : (loaded.mode && insideBand(search, loaded) ? loaded : null);
    var all = from ? url('/collections/all', from.width, from.height, '', from.mode) : '';
    var links = [['clear', withoutSize(path, search), words('clear', 'Clear the size')]];
    if (!/^\/collections\/all\/?$/.test(path) && all) links.push(['all', all, words('all', 'See all doors near this size')]);
    links.push(['ask', words('ask-url', '/pages/request-a-quote'), words('ask', 'Ask us about this size')]);
    var swap = swapOf(from, path, search);
    if (swap) links.unshift(['swap', swap[0], swap[1]]);
    /* another filter counts only with a value: the theme writes empty price boxes into the address on every sort */
    var others = String(search).replace(/^\?/, '').split('&').some(function (p) {
      if (!p) return false;
      var k = keyOf(p), v = p.indexOf('=') < 0 ? '' : p.slice(p.indexOf('=') + 1);
      return k.indexOf('filter.') === 0 && k !== 'filter.v.option.width' && k !== 'filter.v.option.height' && v.trim() !== '';
    });
    var box = document.createElement('div');
    box.className = 'mad-size-none';
    box.setAttribute('data-mad-size-none', '');
    var h = document.createElement('h2');
    h.className = 'title title--primary';
    h.textContent = others
      ? words('title-filtered', 'No doors near this size with the other filters you chose.')
      : words('title', 'No doors near this size here yet.');
    box.appendChild(h);
    var p = document.createElement('p');
    p.className = 'mad-size-none__links';
    links.forEach(function (l, i) {
      var a = document.createElement('a');
      a.className = i === 0 ? 'button button--secondary' : 'link underlined-link';
      a.href = l[1];
      a.textContent = l[2];
      if (l[0] === 'ask') a.setAttribute('data-mad-size-ask', '');
      if (l[0] === 'swap') { a.setAttribute('data-mad-size-swap', ''); a.addEventListener('click', function () { tag('size_finder_swap'); }); }
      p.appendChild(a);
    });
    box.appendChild(p);
    title.style.display = 'none';
    title.parentNode.insertBefore(box, title);
    tag('size_finder_none');
  }

  /* The size this page was loaded with, and whether every width and height value in an address lies inside its band. */
  var loaded = {};
  function insideBand(search, size) {
    var add = TO_OPENING[size.mode] || 0, ok2 = true, any = false;
    String(search || '').replace(/^\?/, '').split('&').forEach(function (p) {
      if (!p) return;
      var k = keyOf(p), dim = k === 'filter.v.option.width' ? 'width' : k === 'filter.v.option.height' ? 'height' : '';
      if (!dim) return;
      var v = Number(decodeURIComponent(p.slice(p.indexOf('=') + 1)));
      var entered = dim === 'width' ? size.width : size.height;
      if (!entered) { ok2 = false; return; }
      var b = band(entered + add, dim);
      any = true;
      if (!(v >= b[0] - 0.001 && v <= b[1] + 0.001)) ok2 = false;
    });
    return any && ok2;
  }

  /* The theme's filters replace the doors (#ProductGridContainer) without a reload: look again each time. */
  function watchGrid() {
    var g = document.getElementById('ProductGridContainer');
    if (!g || !window.MutationObserver || g.hasAttribute('data-mad-size-watch')) return;
    g.setAttribute('data-mad-size-watch', '');
    new MutationObserver(function () { noneNear(); }).observe(g, { childList: true });
  }

  window.MadSizeFinder = { inches: inches, band: band, url: url, sizeFrom: sizeFrom, withoutSize: withoutSize, sizeOnly: sizeOnly, ok: ok, bind: bind, swapOf: swapOf };
  function start() { loaded = sizeFrom(window.location.search); bindAll(); noneNear(); watchGrid(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', resync);
  window.addEventListener('popstate', function () { window.setTimeout(noneNear, 0); });
  document.addEventListener('shopify:section:load', bindAll);
})();
